@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_038_112_529)
public val Res.string.copy_from_reason_inactive: StringResource by lazy {
      StringResource("string:copy_from_reason_inactive", "copy_from_reason_inactive", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76319, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106235, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67674, 69),
      ))
    }

@delegate:ResourceContentHash(1_743_456_803)
public val Res.string.copy_from_reason_unavailable: StringResource by lazy {
      StringResource("string:copy_from_reason_unavailable", "copy_from_reason_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76389, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106329, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67744, 80),
      ))
    }

@delegate:ResourceContentHash(1_986_797_127)
public val Res.string.copy_from_replaced: StringResource by lazy {
      StringResource("string:copy_from_replaced", "copy_from_replaced", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76470, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106450, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67825, 86),
      ))
    }

@delegate:ResourceContentHash(464_980_599)
public val Res.string.copy_from_skipped_closed: StringResource by lazy {
      StringResource("string:copy_from_skipped_closed", "copy_from_skipped_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76569, 132),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106585, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67912, 132),
      ))
    }

@delegate:ResourceContentHash(-114_670_903)
public val Res.string.copy_from_skipped_planned: StringResource by lazy {
      StringResource("string:copy_from_skipped_planned", "copy_from_skipped_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76702, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106774, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68045, 93),
      ))
    }

@delegate:ResourceContentHash(656_201_517)
public val Res.string.copy_from_total: StringResource by lazy {
      StringResource("string:copy_from_total", "copy_from_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76792, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 106908, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68139, 79),
      ))
    }

@delegate:ResourceContentHash(1_343_170_643)
public val Res.string.copy_from_unassigned_in_source: StringResource by lazy {
      StringResource("string:copy_from_unassigned_in_source", "copy_from_unassigned_in_source", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76876, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107020, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68219, 86),
      ))
    }

@delegate:ResourceContentHash(1_416_280_950)
public val Res.string.copy_plan_confirm_text: StringResource by lazy {
      StringResource("string:copy_plan_confirm_text", "copy_plan_confirm_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 76963, 162),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107131, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68306, 146),
      ))
    }

@delegate:ResourceContentHash(-2_140_905_270)
public val Res.string.copy_plan_confirm_title: StringResource by lazy {
      StringResource("string:copy_plan_confirm_title", "copy_plan_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77126, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107346, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68453, 63),
      ))
    }

@delegate:ResourceContentHash(-1_071_069_090)
public val Res.string.copy_plan_day: StringResource by lazy {
      StringResource("string:copy_plan_day", "copy_plan_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77202, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107466, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68517, 53),
      ))
    }

@delegate:ResourceContentHash(1_653_059_181)
public val Res.string.copy_plan_done: StringResource by lazy {
      StringResource("string:copy_plan_done", "copy_plan_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77276, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107552, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68571, 70),
      ))
    }

@delegate:ResourceContentHash(204_194_674)
public val Res.string.copy_plan_nothing: StringResource by lazy {
      StringResource("string:copy_plan_nothing", "copy_plan_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77355, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107659, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68642, 49),
      ))
    }

@delegate:ResourceContentHash(1_739_779_878)
public val Res.string.copy_plan_only_empty: StringResource by lazy {
      StringResource("string:copy_plan_only_empty", "copy_plan_only_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77417, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107753, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68692, 64),
      ))
    }

@delegate:ResourceContentHash(-863_627_258)
public val Res.string.copy_plan_overwrite: StringResource by lazy {
      StringResource("string:copy_plan_overwrite", "copy_plan_overwrite", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77478, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107830, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68757, 39),
      ))
    }

@delegate:ResourceContentHash(523_865_985)
public val Res.string.copy_plan_shift: StringResource by lazy {
      StringResource("string:copy_plan_shift", "copy_plan_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77614, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108006, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68881, 35),
      ))
    }

@delegate:ResourceContentHash(-1_975_763_321)
public val Res.string.copy_plan_shift_description: StringResource by lazy {
      StringResource("string:copy_plan_shift_description", "copy_plan_shift_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77518, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 107890, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68797, 83),
      ))
    }

@delegate:ResourceContentHash(483_026_272)
public val Res.string.copy_planned_add: StringResource by lazy {
      StringResource("string:copy_planned_add", "copy_planned_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77658, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108066, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68917, 80),
      ))
    }

@delegate:ResourceContentHash(-609_698_036)
public val Res.string.copy_planned_replace: StringResource by lazy {
      StringResource("string:copy_planned_replace", "copy_planned_replace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77739, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108195, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68998, 80),
      ))
    }

@delegate:ResourceContentHash(-609_474_758)
public val Res.string.copy_planned_skip: StringResource by lazy {
      StringResource("string:copy_planned_skip", "copy_planned_skip", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77824, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108344, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69079, 73),
      ))
    }

@delegate:ResourceContentHash(817_966_258)
public val Res.string.copy_planned_title: StringResource by lazy {
      StringResource("string:copy_planned_title", "copy_planned_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 77894, 150),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108458, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69153, 154),
      ))
    }

@delegate:ResourceContentHash(1_831_024_479)
public val Res.string.copy_tool_calendar_start: StringResource by lazy {
      StringResource("string:copy_tool_calendar_start", "copy_tool_calendar_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78045, 96),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108653, 128),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69308, 76),
      ))
    }

@delegate:ResourceContentHash(-1_735_049_246)
public val Res.string.copy_tool_calendar_targets: StringResource by lazy {
      StringResource("string:copy_tool_calendar_targets", "copy_tool_calendar_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78142, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108782, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69385, 66),
      ))
    }

@delegate:ResourceContentHash(1_458_298_799)
public val Res.string.copy_tool_from_summary: StringResource by lazy {
      StringResource("string:copy_tool_from_summary", "copy_tool_from_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78217, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108885, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69452, 46),
      ))
    }

@delegate:ResourceContentHash(992_236_540)
public val Res.string.copy_tool_loading_month: StringResource by lazy {
      StringResource("string:copy_tool_loading_month", "copy_tool_loading_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78264, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 108940, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69499, 75),
      ))
    }

@delegate:ResourceContentHash(888_166_973)
public val Res.string.copy_tool_month_unreadable: StringResource by lazy {
      StringResource("string:copy_tool_month_unreadable", "copy_tool_month_unreadable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78348, 214),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109056, 294),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69575, 178),
      ))
    }

@delegate:ResourceContentHash(-2_073_255_970)
public val Res.string.copy_tool_next: StringResource by lazy {
      StringResource("string:copy_tool_next", "copy_tool_next", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78616, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109424, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69799, 38),
      ))
    }

@delegate:ResourceContentHash(1_269_942_252)
public val Res.string.copy_tool_next_month: StringResource by lazy {
      StringResource("string:copy_tool_next_month", "copy_tool_next_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78563, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109351, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69754, 44),
      ))
    }

@delegate:ResourceContentHash(-2_067_429_579)
public val Res.string.copy_tool_pick_days: StringResource by lazy {
      StringResource("string:copy_tool_pick_days", "copy_tool_pick_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78651, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109463, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69838, 47),
      ))
    }

@delegate:ResourceContentHash(-1_892_622_768)
public val Res.string.copy_tool_pick_start: StringResource by lazy {
      StringResource("string:copy_tool_pick_start", "copy_tool_pick_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78695, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109519, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69886, 52),
      ))
    }

@delegate:ResourceContentHash(-1_111_515_266)
public val Res.string.copy_tool_pick_target: StringResource by lazy {
      StringResource("string:copy_tool_pick_target", "copy_tool_pick_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78756, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109592, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 69939, 65),
      ))
    }

@delegate:ResourceContentHash(-373_705_876)
public val Res.string.copy_tool_previous_month: StringResource by lazy {
      StringResource("string:copy_tool_previous_month", "copy_tool_previous_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78830, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109698, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70005, 52),
      ))
    }

@delegate:ResourceContentHash(292_048_205)
public val Res.string.copy_tool_repeat: StringResource by lazy {
      StringResource("string:copy_tool_repeat", "copy_tool_repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78887, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109775, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70058, 60),
      ))
    }

@delegate:ResourceContentHash(-937_162_298)
public val Res.string.copy_tool_step_source: StringResource by lazy {
      StringResource("string:copy_tool_step_source", "copy_tool_step_source", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 78952, 153),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 109868, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70119, 153),
      ))
    }

@delegate:ResourceContentHash(-1_373_257_835)
public val Res.string.copy_tool_step_target_block: StringResource by lazy {
      StringResource("string:copy_tool_step_target_block", "copy_tool_step_target_block", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 79106, 175),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 110102, 255),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70273, 155),
      ))
    }

@delegate:ResourceContentHash(-1_655_467_628)
public val Res.string.copy_tool_step_target_day: StringResource by lazy {
      StringResource("string:copy_tool_step_target_day", "copy_tool_step_target_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 79282, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 110358, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70429, 109),
      ))
    }

@delegate:ResourceContentHash(-826_974_966)
public val Res.string.copy_tool_step_target_month: StringResource by lazy {
      StringResource("string:copy_tool_step_target_month", "copy_tool_step_target_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 79400, 387),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 110520, 567),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70539, 307),
      ))
    }

@delegate:ResourceContentHash(1_132_332_549)
public val Res.string.copy_tool_title: StringResource by lazy {
      StringResource("string:copy_tool_title", "copy_tool_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 79788, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111088, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70847, 39),
      ))
    }

@delegate:ResourceContentHash(-1_907_026_790)
public val Res.string.copy_tool_unreadable: StringResource by lazy {
      StringResource("string:copy_tool_unreadable", "copy_tool_unreadable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 79832, 240),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111152, 340),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70887, 192),
      ))
    }

@delegate:ResourceContentHash(-2_115_985_340)
public val Res.string.copy_tool_week: StringResource by lazy {
      StringResource("string:copy_tool_week", "copy_tool_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80073, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111493, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71080, 34),
      ))
    }

@delegate:ResourceContentHash(-1_775_714_033)
public val Res.string.copy_tool_whole_previous_month: StringResource by lazy {
      StringResource("string:copy_tool_whole_previous_month", "copy_tool_whole_previous_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80116, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111544, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71115, 66),
      ))
    }

@delegate:ResourceContentHash(1_761_919_058)
public val Res.string.copy_tool_workdays: StringResource by lazy {
      StringResource("string:copy_tool_workdays", "copy_tool_workdays", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80187, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111643, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71182, 50),
      ))
    }

@delegate:ResourceContentHash(1_422_880_375)
public val Res.string.copy_undo: StringResource by lazy {
      StringResource("string:copy_undo", "copy_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80306, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111802, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71289, 25),
      ))
    }

@delegate:ResourceContentHash(1_069_078_223)
public val Res.string.copy_undone: StringResource by lazy {
      StringResource("string:copy_undone", "copy_undone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80242, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111706, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71233, 55),
      ))
    }

@delegate:ResourceContentHash(469_558_051)
public val Res.string.cost_kind_one_off: StringResource by lazy {
      StringResource("string:cost_kind_one_off", "cost_kind_one_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80332, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111844, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71315, 37),
      ))
    }

@delegate:ResourceContentHash(106_963_942)
public val Res.string.cost_kind_rule: StringResource by lazy {
      StringResource("string:cost_kind_rule", "cost_kind_rule", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80374, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111886, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71353, 30),
      ))
    }

@delegate:ResourceContentHash(-2_144_580_316)
public val Res.string.cost_kind_shared: StringResource by lazy {
      StringResource("string:cost_kind_shared", "cost_kind_shared", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80405, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111933, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71384, 32),
      ))
    }

@delegate:ResourceContentHash(-170_821_412)
public val Res.string.cost_rule_added: StringResource by lazy {
      StringResource("string:cost_rule_added", "cost_rule_added", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80442, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 111978, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71417, 51),
      ))
    }

@delegate:ResourceContentHash(-1_560_638_390)
public val Res.string.cost_rule_deleted: StringResource by lazy {
      StringResource("string:cost_rule_deleted", "cost_rule_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80490, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112066, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71469, 53),
      ))
    }

@delegate:ResourceContentHash(-130_349_441)
public val Res.string.cost_rule_updated: StringResource by lazy {
      StringResource("string:cost_rule_updated", "cost_rule_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80544, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112160, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71523, 53),
      ))
    }

@delegate:ResourceContentHash(1_648_250_806)
public val Res.string.cost_rules_add: StringResource by lazy {
      StringResource("string:cost_rules_add", "cost_rules_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80776, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112512, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71723, 50),
      ))
    }

@delegate:ResourceContentHash(1_699_758_380)
public val Res.string.cost_rules_add_first: StringResource by lazy {
      StringResource("string:cost_rules_add_first", "cost_rules_add_first", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80602, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112254, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71577, 80),
      ))
    }

@delegate:ResourceContentHash(1_549_003_278)
public val Res.string.cost_rules_add_title: StringResource by lazy {
      StringResource("string:cost_rules_add_title", "cost_rules_add_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80695, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112395, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71658, 64),
      ))
    }

@delegate:ResourceContentHash(-1_327_099_947)
public val Res.string.cost_rules_amount: StringResource by lazy {
      StringResource("string:cost_rules_amount", "cost_rules_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80835, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112595, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71774, 45),
      ))
    }

@delegate:ResourceContentHash(-340_453_955)
public val Res.string.cost_rules_applies_to: StringResource by lazy {
      StringResource("string:cost_rules_applies_to", "cost_rules_applies_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80877, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112641, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71820, 53),
      ))
    }

@delegate:ResourceContentHash(-1_739_112_160)
public val Res.string.cost_rules_convert: StringResource by lazy {
      StringResource("string:cost_rules_convert", "cost_rules_convert", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80927, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112707, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71874, 58),
      ))
    }

@delegate:ResourceContentHash(-1_775_563_480)
public val Res.string.cost_rules_delete_confirm: StringResource by lazy {
      StringResource("string:cost_rules_delete_confirm", "cost_rules_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 80990, 141),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 112810, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 71933, 129),
      ))
    }

@delegate:ResourceContentHash(1_867_510_964)
public val Res.string.cost_rules_edit_title: StringResource by lazy {
      StringResource("string:cost_rules_edit_title", "cost_rules_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81132, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113012, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72063, 69),
      ))
    }

@delegate:ResourceContentHash(-834_702_828)
public val Res.string.cost_rules_empty: StringResource by lazy {
      StringResource("string:cost_rules_empty", "cost_rules_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81332, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113324, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72239, 68),
      ))
    }

@delegate:ResourceContentHash(1_000_982_978)
public val Res.string.cost_rules_empty_hint: StringResource by lazy {
      StringResource("string:cost_rules_empty_hint", "cost_rules_empty_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81214, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113138, 185),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72133, 105),
      ))
    }

@delegate:ResourceContentHash(-19_485_316)
public val Res.string.cost_rules_frequency: StringResource by lazy {
      StringResource("string:cost_rules_frequency", "cost_rules_frequency", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81413, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113441, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72308, 40),
      ))
    }

@delegate:ResourceContentHash(1_089_556_379)
public val Res.string.cost_rules_manage: StringResource by lazy {
      StringResource("string:cost_rules_manage", "cost_rules_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81466, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113490, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72349, 69),
      ))
    }

@delegate:ResourceContentHash(455_828_229)
public val Res.string.cost_rules_name_hint: StringResource by lazy {
      StringResource("string:cost_rules_name_hint", "cost_rules_name_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81556, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113620, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72419, 72),
      ))
    }

@delegate:ResourceContentHash(1_246_482_188)
public val Res.string.cost_rules_one_off_hint: StringResource by lazy {
      StringResource("string:cost_rules_one_off_hint", "cost_rules_one_off_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81637, 119),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113761, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72492, 103),
      ))
    }

@delegate:ResourceContentHash(-734_330_389)
public val Res.string.cost_rules_one_off_moved: StringResource by lazy {
      StringResource("string:cost_rules_one_off_moved", "cost_rules_one_off_moved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81757, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 113945, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72596, 100),
      ))
    }

@delegate:ResourceContentHash(-1_822_360_778)
public val Res.string.cost_rules_title: StringResource by lazy {
      StringResource("string:cost_rules_title", "cost_rules_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81878, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114106, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72697, 60),
      ))
    }

@delegate:ResourceContentHash(1_063_749_081)
public val Res.string.cost_rules_workplace: StringResource by lazy {
      StringResource("string:cost_rules_workplace", "cost_rules_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81943, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114199, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72758, 40),
      ))
    }

@delegate:ResourceContentHash(-1_910_919_535)
public val Res.string.counter_days_left: StringResource by lazy {
      StringResource("string:counter_days_left", "counter_days_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 81980, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114244, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72799, 57),
      ))
    }

@delegate:ResourceContentHash(-1_660_576_883)
public val Res.string.counter_hint_only: StringResource by lazy {
      StringResource("string:counter_hint_only", "counter_hint_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82042, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114326, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72857, 93),
      ))
    }

@delegate:ResourceContentHash(-450_330_793)
public val Res.string.counter_hours_left: StringResource by lazy {
      StringResource("string:counter_hours_left", "counter_hours_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82140, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114480, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72951, 58),
      ))
    }

@delegate:ResourceContentHash(355_748_972)
public val Res.string.counter_overtime_left: StringResource by lazy {
      StringResource("string:counter_overtime_left", "counter_overtime_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82207, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114567, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73010, 89),
      ))
    }

@delegate:ResourceContentHash(-2_015_482_889)
public val Res.string.counter_overtime_ratio: StringResource by lazy {
      StringResource("string:counter_overtime_ratio", "counter_overtime_ratio", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82444, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114940, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73223, 102),
      ))
    }

@delegate:ResourceContentHash(-1_496_354_673)
public val Res.string.counter_overtime_ratio_for: StringResource by lazy {
      StringResource("string:counter_overtime_ratio_for", "counter_overtime_ratio_for", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82313, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 114745, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73100, 122),
      ))
    }

@delegate:ResourceContentHash(-2_043_807_032)
public val Res.string.counter_overtime_title: StringResource by lazy {
      StringResource("string:counter_overtime_title", "counter_overtime_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82567, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115115, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73326, 70),
      ))
    }

@delegate:ResourceContentHash(244_028_394)
public val Res.string.counter_pending: StringResource by lazy {
      StringResource("string:counter_pending", "counter_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82630, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115226, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73397, 63),
      ))
    }

@delegate:ResourceContentHash(1_273_361_659)
public val Res.string.counter_title: StringResource by lazy {
      StringResource("string:counter_title", "counter_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82686, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115302, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73461, 37),
      ))
    }

@delegate:ResourceContentHash(1_883_304_777)
public val Res.string.course_add_image_page: StringResource by lazy {
      StringResource("string:course_add_image_page", "course_add_image_page", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82732, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115352, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73499, 41),
      ))
    }

@delegate:ResourceContentHash(-1_070_809_463)
public val Res.string.course_add_option: StringResource by lazy {
      StringResource("string:course_add_option", "course_add_option", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82770, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115410, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73541, 45),
      ))
    }

@delegate:ResourceContentHash(-777_983_462)
public val Res.string.course_add_presentation_page: StringResource by lazy {
      StringResource("string:course_add_presentation_page", "course_add_presentation_page", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82820, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115480, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73587, 52),
      ))
    }

@delegate:ResourceContentHash(-349_680_348)
public val Res.string.course_add_question: StringResource by lazy {
      StringResource("string:course_add_question", "course_add_question", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82873, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115549, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73640, 47),
      ))
    }

@delegate:ResourceContentHash(1_818_058_978)
public val Res.string.course_add_text_page: StringResource by lazy {
      StringResource("string:course_add_text_page", "course_add_text_page", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82921, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115621, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73688, 40),
      ))
    }

@delegate:ResourceContentHash(882_928_585)
public val Res.string.course_add_video_page: StringResource by lazy {
      StringResource("string:course_add_video_page", "course_add_video_page", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 82974, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115694, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73729, 45),
      ))
    }

@delegate:ResourceContentHash(-2_014_372_410)
public val Res.string.course_all_new_hires: StringResource by lazy {
      StringResource("string:course_all_new_hires", "course_all_new_hires", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83090, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115866, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73857, 72),
      ))
    }

@delegate:ResourceContentHash(12_864_617)
public val Res.string.course_all_new_hires_hint: StringResource by lazy {
      StringResource("string:course_all_new_hires_hint", "course_all_new_hires_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83024, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115772, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73775, 81),
      ))
    }

@delegate:ResourceContentHash(-831_525_901)
public val Res.string.course_answer_all: StringResource by lazy {
      StringResource("string:course_answer_all", "course_answer_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83175, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 115971, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73930, 65),
      ))
    }

@delegate:ResourceContentHash(1_248_138_168)
public val Res.string.course_answers_private: StringResource by lazy {
      StringResource("string:course_answers_private", "course_answers_private", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83257, 190),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116093, 286),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73996, 178),
      ))
    }

@delegate:ResourceContentHash(-1_103_075_332)
public val Res.string.course_assign: StringResource by lazy {
      StringResource("string:course_assign", "course_assign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83696, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116716, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74395, 41),
      ))
    }

@delegate:ResourceContentHash(264_189_375)
public val Res.string.course_assign_action: StringResource by lazy {
      StringResource("string:course_assign_action", "course_assign_action", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83448, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116380, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74175, 36),
      ))
    }

@delegate:ResourceContentHash(-453_158_221)
public val Res.string.course_assign_due: StringResource by lazy {
      StringResource("string:course_assign_due", "course_assign_due", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83489, 89),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116437, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74212, 73),
      ))
    }

@delegate:ResourceContentHash(-1_848_786_151)
public val Res.string.course_assign_people: StringResource by lazy {
      StringResource("string:course_assign_people", "course_assign_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83579, 36),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116555, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74286, 36),
      ))
    }

@delegate:ResourceContentHash(417_905_749)
public val Res.string.course_assigned_message: StringResource by lazy {
      StringResource("string:course_assigned_message", "course_assigned_message", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83616, 79),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116596, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74323, 71),
      ))
    }

@delegate:ResourceContentHash(107_500_601)
public val Res.string.course_attempts_left: StringResource by lazy {
      StringResource("string:course_attempts_left", "course_attempts_left", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83738, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116782, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74437, 64),
      ))
    }

@delegate:ResourceContentHash(-1_086_099_711)
public val Res.string.course_back: StringResource by lazy {
      StringResource("string:course_back", "course_back", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83811, 27),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116891, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74502, 27),
      ))
    }

@delegate:ResourceContentHash(-1_442_015_161)
public val Res.string.course_choose_image: StringResource by lazy {
      StringResource("string:course_choose_image", "course_choose_image", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83839, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 116927, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74530, 51),
      ))
    }

@delegate:ResourceContentHash(494_896_124)
public val Res.string.course_close: StringResource by lazy {
      StringResource("string:course_close", "course_close", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83887, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 117003, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74582, 28),
      ))
    }

@delegate:ResourceContentHash(1_208_225_040)
public val Res.string.course_consultation: StringResource by lazy {
      StringResource("string:course_consultation", "course_consultation", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83920, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 117044, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74611, 83),
      ))
    }

@delegate:ResourceContentHash(585_289_393)
public val Res.string.course_counts_for_readiness: StringResource by lazy {
      StringResource("string:course_counts_for_readiness", "course_counts_for_readiness", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84133, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 117421, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74824, 79),
      ))
    }

@delegate:ResourceContentHash(343_720_780)
public val Res.string.course_counts_for_readiness_hint: StringResource by lazy {
      StringResource("string:course_counts_for_readiness_hint", "course_counts_for_readiness_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 83996, 136),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 117180, 240),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74695, 128),
      ))
    }

@delegate:ResourceContentHash(326_433_326)
public val Res.string.course_delete: StringResource by lazy {
      StringResource("string:course_delete", "course_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84462, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 117954, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75121, 45),
      ))
    }

@delegate:ResourceContentHash(298_951_749)
public val Res.string.course_delete_confirm: StringResource by lazy {
      StringResource("string:course_delete_confirm", "course_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84217, 201),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 117545, 349),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74904, 173),
      ))
    }

@delegate:ResourceContentHash(1_421_240_442)
public val Res.string.course_deleted: StringResource by lazy {
      StringResource("string:course_deleted", "course_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 84419, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 117895, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75078, 42),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString9Resources(map: MutableMap<String, StringResource>) {
  map.put("copy_from_reason_inactive", Res.string.copy_from_reason_inactive)
  map.put("copy_from_reason_unavailable", Res.string.copy_from_reason_unavailable)
  map.put("copy_from_replaced", Res.string.copy_from_replaced)
  map.put("copy_from_skipped_closed", Res.string.copy_from_skipped_closed)
  map.put("copy_from_skipped_planned", Res.string.copy_from_skipped_planned)
  map.put("copy_from_total", Res.string.copy_from_total)
  map.put("copy_from_unassigned_in_source", Res.string.copy_from_unassigned_in_source)
  map.put("copy_plan_confirm_text", Res.string.copy_plan_confirm_text)
  map.put("copy_plan_confirm_title", Res.string.copy_plan_confirm_title)
  map.put("copy_plan_day", Res.string.copy_plan_day)
  map.put("copy_plan_done", Res.string.copy_plan_done)
  map.put("copy_plan_nothing", Res.string.copy_plan_nothing)
  map.put("copy_plan_only_empty", Res.string.copy_plan_only_empty)
  map.put("copy_plan_overwrite", Res.string.copy_plan_overwrite)
  map.put("copy_plan_shift", Res.string.copy_plan_shift)
  map.put("copy_plan_shift_description", Res.string.copy_plan_shift_description)
  map.put("copy_planned_add", Res.string.copy_planned_add)
  map.put("copy_planned_replace", Res.string.copy_planned_replace)
  map.put("copy_planned_skip", Res.string.copy_planned_skip)
  map.put("copy_planned_title", Res.string.copy_planned_title)
  map.put("copy_tool_calendar_start", Res.string.copy_tool_calendar_start)
  map.put("copy_tool_calendar_targets", Res.string.copy_tool_calendar_targets)
  map.put("copy_tool_from_summary", Res.string.copy_tool_from_summary)
  map.put("copy_tool_loading_month", Res.string.copy_tool_loading_month)
  map.put("copy_tool_month_unreadable", Res.string.copy_tool_month_unreadable)
  map.put("copy_tool_next", Res.string.copy_tool_next)
  map.put("copy_tool_next_month", Res.string.copy_tool_next_month)
  map.put("copy_tool_pick_days", Res.string.copy_tool_pick_days)
  map.put("copy_tool_pick_start", Res.string.copy_tool_pick_start)
  map.put("copy_tool_pick_target", Res.string.copy_tool_pick_target)
  map.put("copy_tool_previous_month", Res.string.copy_tool_previous_month)
  map.put("copy_tool_repeat", Res.string.copy_tool_repeat)
  map.put("copy_tool_step_source", Res.string.copy_tool_step_source)
  map.put("copy_tool_step_target_block", Res.string.copy_tool_step_target_block)
  map.put("copy_tool_step_target_day", Res.string.copy_tool_step_target_day)
  map.put("copy_tool_step_target_month", Res.string.copy_tool_step_target_month)
  map.put("copy_tool_title", Res.string.copy_tool_title)
  map.put("copy_tool_unreadable", Res.string.copy_tool_unreadable)
  map.put("copy_tool_week", Res.string.copy_tool_week)
  map.put("copy_tool_whole_previous_month", Res.string.copy_tool_whole_previous_month)
  map.put("copy_tool_workdays", Res.string.copy_tool_workdays)
  map.put("copy_undo", Res.string.copy_undo)
  map.put("copy_undone", Res.string.copy_undone)
  map.put("cost_kind_one_off", Res.string.cost_kind_one_off)
  map.put("cost_kind_rule", Res.string.cost_kind_rule)
  map.put("cost_kind_shared", Res.string.cost_kind_shared)
  map.put("cost_rule_added", Res.string.cost_rule_added)
  map.put("cost_rule_deleted", Res.string.cost_rule_deleted)
  map.put("cost_rule_updated", Res.string.cost_rule_updated)
  map.put("cost_rules_add", Res.string.cost_rules_add)
  map.put("cost_rules_add_first", Res.string.cost_rules_add_first)
  map.put("cost_rules_add_title", Res.string.cost_rules_add_title)
  map.put("cost_rules_amount", Res.string.cost_rules_amount)
  map.put("cost_rules_applies_to", Res.string.cost_rules_applies_to)
  map.put("cost_rules_convert", Res.string.cost_rules_convert)
  map.put("cost_rules_delete_confirm", Res.string.cost_rules_delete_confirm)
  map.put("cost_rules_edit_title", Res.string.cost_rules_edit_title)
  map.put("cost_rules_empty", Res.string.cost_rules_empty)
  map.put("cost_rules_empty_hint", Res.string.cost_rules_empty_hint)
  map.put("cost_rules_frequency", Res.string.cost_rules_frequency)
  map.put("cost_rules_manage", Res.string.cost_rules_manage)
  map.put("cost_rules_name_hint", Res.string.cost_rules_name_hint)
  map.put("cost_rules_one_off_hint", Res.string.cost_rules_one_off_hint)
  map.put("cost_rules_one_off_moved", Res.string.cost_rules_one_off_moved)
  map.put("cost_rules_title", Res.string.cost_rules_title)
  map.put("cost_rules_workplace", Res.string.cost_rules_workplace)
  map.put("counter_days_left", Res.string.counter_days_left)
  map.put("counter_hint_only", Res.string.counter_hint_only)
  map.put("counter_hours_left", Res.string.counter_hours_left)
  map.put("counter_overtime_left", Res.string.counter_overtime_left)
  map.put("counter_overtime_ratio", Res.string.counter_overtime_ratio)
  map.put("counter_overtime_ratio_for", Res.string.counter_overtime_ratio_for)
  map.put("counter_overtime_title", Res.string.counter_overtime_title)
  map.put("counter_pending", Res.string.counter_pending)
  map.put("counter_title", Res.string.counter_title)
  map.put("course_add_image_page", Res.string.course_add_image_page)
  map.put("course_add_option", Res.string.course_add_option)
  map.put("course_add_presentation_page", Res.string.course_add_presentation_page)
  map.put("course_add_question", Res.string.course_add_question)
  map.put("course_add_text_page", Res.string.course_add_text_page)
  map.put("course_add_video_page", Res.string.course_add_video_page)
  map.put("course_all_new_hires", Res.string.course_all_new_hires)
  map.put("course_all_new_hires_hint", Res.string.course_all_new_hires_hint)
  map.put("course_answer_all", Res.string.course_answer_all)
  map.put("course_answers_private", Res.string.course_answers_private)
  map.put("course_assign", Res.string.course_assign)
  map.put("course_assign_action", Res.string.course_assign_action)
  map.put("course_assign_due", Res.string.course_assign_due)
  map.put("course_assign_people", Res.string.course_assign_people)
  map.put("course_assigned_message", Res.string.course_assigned_message)
  map.put("course_attempts_left", Res.string.course_attempts_left)
  map.put("course_back", Res.string.course_back)
  map.put("course_choose_image", Res.string.course_choose_image)
  map.put("course_close", Res.string.course_close)
  map.put("course_consultation", Res.string.course_consultation)
  map.put("course_counts_for_readiness", Res.string.course_counts_for_readiness)
  map.put("course_counts_for_readiness_hint", Res.string.course_counts_for_readiness_hint)
  map.put("course_delete", Res.string.course_delete)
  map.put("course_delete_confirm", Res.string.course_delete_confirm)
  map.put("course_deleted", Res.string.course_deleted)
}
